import { IClassname } from '@/lib/shared/model/classname';

export const FloorSVG = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.66602 26.6665H26.3328"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.3323 12.2905H20.4917C20.3725 12.2905 20.2583 12.3379 20.174 12.4221C20.0898 12.5064 20.0424 12.6206 20.0424 12.7398V15.8847H16.8975C16.8385 15.8847 16.7801 15.8964 16.7255 15.9189C16.671 15.9415 16.6215 15.9746 16.5798 16.0163C16.5381 16.0581 16.505 16.1076 16.4824 16.1621C16.4598 16.2166 16.4482 16.275 16.4482 16.334V19.479H13.3033C13.2443 19.479 13.1858 19.4906 13.1313 19.5132C13.0768 19.5357 13.0273 19.5688 12.9856 19.6106C12.9439 19.6523 12.9108 19.7018 12.8882 19.7563C12.8656 19.8108 12.854 19.8692 12.854 19.9282V23.0732H9.70904C9.58989 23.0732 9.47561 23.1205 9.39136 23.2048C9.3071 23.289 9.25977 23.4033 9.25977 23.5225V26.6674"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.66602 15.8841L15.5501 6"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0576 6H15.5504V10.4928"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
